import React, { Component } from 'react';
import videojs from 'video.js';
import { sendData } from '../../analytics/sendData';
import panorama from '../../libraries/videojs-panorama.common';
import 'video.js/dist/video-js.css';


 class Play360Video extends Component {
    isIos() {
        return /iPhone|iPad|iPod/i.test(navigator.userAgent);
    }
  
    isMobile() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  
    componentDidMount() {
      if(this.isMobile()) {
          document.body.classList.add("mobile-page");
      } else {
          document.body.classList.remove("mobile-page");
      }
      if(this.isIos()) {
          document.body.classList.add("ios-page");
      } else {
          document.body.classList.remove("ios-page");
      }
      let player = this.player;
      let isIos = this.isIos();
      let isMobile = this.isMobile();
      const videoJsOptions = {
          autoplay: true,
          controls: true,
          sources: [{
            src: this.props.source,
            type: 'video/mp4'
          }],
      };
      const { rid, vname, vcategory } = this.props.data;
      const videoTitle = vname;
      const videoCategory = vcategory;
      console.log("llll=>", videoTitle )
      player = videojs(this.videoNode, videoJsOptions, function onPlayerReady() {
          sendData(videoTitle, videoCategory, 'video', 'watched', {
              "watched": "0%",
              "finished": false
          });
          window.addEventListener("resize", function () {
              var canvas = player.getChild('Canvas');
              canvas.handleResize();
          });
          if(isMobile) {
              player.landscapeFullscreen({
                  fullscreen: {
                    enterOnRotate: true,
                    alwaysInLandscapeMode: true,
                    iOS: true
                  }
              });
          }
          player.on('ended', function () {
              sendData(videoTitle, videoCategory, 'video', 'watched', {
                  "watched" : "100%",
                   "finished": true
                  })
          });
          player.on('error', function (e) {
              e.stopImmediatePropagation();
              var error = this.player().error();
              sendData(videoTitle, videoCategory, 'video', 'watched', {
                  "url": window.location.href,
                  "error": true,
                  "error_message": error.message
              })
          });
  
          player.on('stalled', function () {
          });
          player.on('waiting', function () {
          });
         
      });
      this.panorama = player.panorama({
          PanoramaThumbnail: true,
          KeyboardControl: true,
          clickToToggle: true,
          clickAndDrag: true,
          autoplay: true,
          autoHeight: false,
          autoMobileOrientation: true,
          mobileVibrationValue: this.isIos()? 0.032 : 0.05,
          callback: function () {
            player.play();
          },
          Notice: {
              Enable: true,
              Message: "",
          },
          Markers: [
              {
                  location: {
                      lat: 0,
                      lon: 180
                  },
                  radius: 500,
                  element: "This is text 1 with long text"
              },
              {
                  location: {
                      lat: 20,
                      lon: 160
                  },
                  radius: 500,
                  element: "This is text 2 with long text",
                  onShow: function(){
                  },
                  onHide: function(){
                  }
              }
          ],
          Animation: [
              {
                  keyPoint: 0,
                  from: {
                      lon: 180,
                  },
                  to:{
                      lon: 540,
                  },
                  duration: 8000,
                  ease: "linear",
                  onComplete: function () {
                  }
              },
              {
                  keyPoint: 0,
                  from: {
                      fov: 75,
                  },
                  to:{
                      fov: 90,
                  },
                  duration: 5000,
                  ease: "linear",
              }
          ],
      });
    }
  
    componentWillUnmount() {
      if (this.player) {
        this.player.dispose();
      }
      if(document.body.classList.contains("mobile-page")) {
          document.body.classList.remove("mobile-page");
      }
      if(document.body.classList.contains("ios-page")) {
          document.body.classList.remove("ios-page");
      }
    }
  
    render() {
      return (
        <div className="video360-wrapper">
          <div className="video360-inner">
              <div>
                  <div data-vjs-player>
                      <video ref={ node => this.videoNode = node } 
                       crossOrigin="anonymous" cors="anonymous" 
                      autoPlay className="video-js vjs-big-play-centered"></video>
                  </div>
              </div>
          </div>
        </div>
      )
    }
  }

  export default Play360Video;


// WEBPACK FOOTER //
// ./src/components/ClapprPlayer/Play360Video.js